import { Box } from "@material-ui/core";
import { styled } from "@mui/system";
import React, { useState } from "react";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

import { offer_id, offer_name, tag_id, tag_name } from "../../../constants";
import { primary } from "../../../constants/theme";
import { sendAnalytics } from "../../../utils/analyticsCommon";
import { useMobile } from "../../../utils/findViewport";

const CustomImageSlider = styled(Box)(({ theme }) => ({
  padding: "0px 0px 0px 0px",
  ".image-gallery-icon.image-gallery-fullscreen-button": {
    display: "none",
  },
  ".image-gallery-icon.image-gallery-play-button": {
    display: "none",
  },
  ".image-gallery-content .image-gallery-slide .image-gallery-image": {
    height: "600px",
    minHeight: "600px",
  },
  ".image-gallery-svg": {
    height: "40px",
    filter: "unset",
    marginTop: "4px",
  },
  ".image-gallery-icon": {
    filter: "unset",
    color: "#ffffff",
    fontSize: "50px",
    borderRadius: "50%",
    width: "41.5px",
    height: "41.5px",
    padding: "unset",
  },
  ".image-gallery-bullets .image-gallery-bullet": {
    background: "#EBEBEB",
    boxShadow: "unset",
    width: "13.14px",
    height: "13.14px",
  },
  ".image-gallery-bullets .image-gallery-bullet.active": {
    transform: "unset",
    background: primary.main,
  },
  ".image-gallery-thumbnails .image-gallery-thumbnails-container": {
    height: "100px",
  },
  ".image-gallery-thumbnail.active, .image-gallery-thumbnail:focus, .image-gallery-thumbnail:hover":
    {
      border: "1.6px solid #E8345E",
      transition: "unset",
    },
  ".image-gallery-thumbnail": {
    transition: "unset",
    width: "96px",
    height: "72px",
    border: "1.6px solid #D9D9D9",
    borderRadius: "8.2px",
    marginLeft: "24px   ",
  },
  ".image-gallery-thumbnail-label": {
    fontWeight: "500",
    fontSize: "18px",
    lineHeight: "150%",
    color: "#BCBCBC",
    transform: "unset",
    position: "relative",
    textShadow: "unset",
  },
  ".image-gallery-thumbnail.active .image-gallery-thumbnail-label": {
    color: "#000",
    fontWeight: "600",
  },
  ".image-gallery-thumbnail img": {
    width: "84px",
    height: "68px",
  },
  ".brand-logo": {
    width: "20%",
    position: "absolute",
    zIndex: "99",
    top: "60px",
    left: "10%",
  },
  ".view-360": {
    margin: "30px 50px",
  },
  ".view-image": {
    margin: "0px",
  },
  [theme.breakpoints.down("md")]: {
    padding: "0px 0px",
    ".image-gallery-content .image-gallery-slide .image-gallery-image": {
      height: "360px",
      minHeight: "360px",
    },
    ".image-gallery-thumbnail": {
      marginLeft: "8px",
      borderRadius: "5px",
      height: "44px",
      marginRight: "7.5px",
      width: "58.67px",
    },
    ".image-gallery-thumbnail img": {
      height: "40px",
      width: "95%",
    },
    ".image-gallery-thumbnail-label": {
      fontSize: "12px",
      lineHeight: "18px",
      padding: "6px 0px",
    },
    ".image-gallery-bullets .image-gallery-bullet": {
      width: "8px",
      height: "8px",
    },
    ".image-gallery-thumbnails .image-gallery-thumbnails-container": {
      height: "60px",
    },
    ".brand-logo": {
      width: "20%",
      position: "absolute",
      zIndex: "99",
      top: "60px",
      left: "30px",
    },
    ".view-360": {
      margin: "0px",
    },
  },
}));

const ImageSlider = ({ vehicleData, images, handleThumbnailClick }) => {
  const [view360, setView360] = useState(false);
  const mobile = useMobile();

  return images ? (
    <CustomImageSlider>
      <LazyLoadImage
        src={vehicleData?.vehicle_logo}
        alt={vehicleData?.name}
        effect="opacity"
        className="brand-logo"
        style={{ left: view360 ? "10%" : "15%" }}
      />
      {/* {view360 === false ? (
        <LazyLoadImage
          alt="Turnable image 8"
          src={imagesList.view_360}
          style={{
            position: "absolute",
            top: "70%",
            right: mobile ? "5%" : "15%",
            zIndex: "99",
          }}
          onClick={() => {
            sendAnalytics("360_view_clicked", {}, "en");
            setView360(true);
          }}
        />
      ) : (
        <Box
          style={{
            position: "absolute",
            top: "80%",
            right: mobile ? "5%" : "10%",
            zIndex: "99",
          }}
          onClick={() => {
            sendAnalytics("image_gallery_view_clicked", {}, "en");
            setView360(false);
          }}
        >
          <CollectionsIcon />
        </Box>
      )} */}
      <Box style={{ height: "400px" }}>
        <Box className="view-image">
          <ImageGallery
            lazyLoad={true}
            style={{ height: "400px" }}
            items={images}
            showBullets={true}
            thumbnailPosition="bottom"
            showNav={true}
            autoPlay={false}
            onThumbnailClick={(event, currentIndex) => {
              handleThumbnailClick(images[currentIndex]);
            }}
            onSlide={(currentIndex) => {
              if (images[currentIndex]?.type !== "") {
                handleThumbnailClick(images[currentIndex]);
              }
              localStorage.setItem("slided", "true");
              let payload = {
                vehicle_name: vehicleData?.name ?? "",
                vehicle_id: vehicleData?.vehicle_id ?? "",
                emi_shown: vehicleData?.emiPrice ?? "",
                price_shown: vehicleData?.price ?? "",
                offer_name: offer_name,
                offer_id: offer_id,
                tag_name: tag_name,
                tag_id: tag_id,
                index: currentIndex,
              };
              sendAnalytics("vehicle_scroll_button_clicked", payload, "en");
            }}
          />
        </Box>
        {/* {view360 === true ? (
          <Box className="view-360">
            <ReactImageTurntable images={vehicleData?.view360Images} />
          </Box>
        ) : (
          <Box className="view-image">
            <ImageGallery
              lazyLoad={true}
              style={{ height: "400px" }}
              items={images}
              showBullets={true}
              thumbnailPosition="bottom"
              showNav={true}
              autoPlay={false}
              onThumbnailClick={(event, currentIndex) => {
                handleThumbnailClick(images[currentIndex]);
              }}
              onSlide={(currentIndex) => {
                if (images[currentIndex]?.type !== "") {
                  handleThumbnailClick(images[currentIndex]);
                }
                localStorage.setItem("slided", "true");
                localStorage.setItem(
                  "vehicleData",
                  JSON.stringify(vehicleData)
                );
                let payload = {
                  vehicle_name: vehicleData?.name ?? "",
                  vehicle_id: vehicleData?.vehicle_id ?? "",
                  emi_shown: vehicleData?.emiPrice ?? "",
                  price_shown: vehicleData?.price ?? "",
                  offer_name: offer_name,
                  offer_id: offer_id,
                  tag_name: tag_name,
                  tag_id: tag_id,
                  index: currentIndex,
                };
                sendAnalytics("vehicle_scroll_button_clicked", payload, "en");
              }}
            />
          </Box>
        )} */}
      </Box>
    </CustomImageSlider>
  ) : null;
};
// export default ImageSlider;

export const MemoizedImageSlider = React.memo(ImageSlider);
